import React, { useState, useEffect } from "react";
import Collapse from "@mui/material/Collapse";
import { useRouter } from "next/router";
import Link from "next/link";
import { useMediaQuery } from "react-responsive";
import { ReactSVG } from "react-svg";
import { getAssets } from "@unisearch/helpers";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { IconButton } from "@mui/material";
import styles from "./group_list.module.scss";

const GroupList = ({ groupList }) => {
  const { asPath, query } = useRouter();
  const isMobile = useMediaQuery({
    query: "(max-width: 991px)",
  });
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.heading}>
        <span>Groups</span>
        {isMobile && (
          <IconButton disableRipple>
            {open ? (
              <FiChevronUp onClick={handleClick} />
            ) : (
              <FiChevronDown onClick={handleClick} />
            )}
          </IconButton>
        )}
      </div>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <ul className={styles.group_list}>
          {groupList &&
            groupList?.length > 0 &&
            groupList?.map((item, i) => (
              <li key={i}>
                <Link legacyBehavior href={`/forum/group/${item.slug}`}>
                  <a
                    className={`${styles.list} ${
                      item.slug === query.group_slug ? styles.active : ""
                    }`}
                  >
                    <div className={styles.item_icon}>
                      <ReactSVG
                        src={getAssets("assets/icons/equalizer-stats.svg")}
                      />
                    </div>
                    <span className={styles.title}>{item.title}</span>
                    {/* <span className={styles.notify}>{item.notice}</span> */}
                  </a>
                </Link>
              </li>
            ))}
        </ul>
      </Collapse>
    </div>
  );
};

export default GroupList;
